import { render, staticRenderFns } from "./TaxPeriodList.vue?vue&type=template&id=4f1b224b&scoped=true"
import script from "./TaxPeriodList.vue?vue&type=script&lang=js"
export * from "./TaxPeriodList.vue?vue&type=script&lang=js"
import style0 from "./TaxPeriodList.vue?vue&type=style&index=0&id=4f1b224b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b224b",
  null
  
)

export default component.exports